import { typedStyles } from '@/utils/styleUtils';

import { APP_ZOOM } from '@/styles/portalLayout';

export const styles = typedStyles({
  /**
   * Portal target for the tooltip. Cancels the app-wide html zoom so MUI Popper's measure and
   * write units match (see the component comment). Absolute with zero size, so it takes no
   * layout space even when the caller positions the button absolutely.
   */
  tooltipContainer: {
    position: 'absolute',
    width: 0,
    height: 0,
    zoom: 1 / APP_ZOOM,
  },

  /**
   * Wraps a disabled button so the Tooltip still gets hover events (a disabled button fires
   * none). `inline-flex` keeps the wrapper the size of the button.
   */
  disabledWrapper: {
    display: 'inline-flex',
  },

  /**
   * Styles the tooltip box from its popper. Identical to TitleWithInfo's tooltip: dark ink
   * surface, white body2 text, 8px radius, max 240px wide, 8px gap under the icon.
   * `zoom: APP_ZOOM` puts back the 85% size the counter-zoom container removed. `&&` raises the
   * gap rule above MUI's own 14px top margin for bottom placement.
   */
  tooltipPopper: {
    '& .MuiTooltip-tooltip': {
      zoom: APP_ZOOM,
      backgroundColor: 'custom.primary',
      color: 'custom.secondary',
      typography: 'body2',
      lineHeight: '20px',
      paddingY: 1.25,
      paddingX: 1.5,
      borderRadius: 2,
      maxWidth: 240,
    },
    '&&[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
      marginTop: 1,
    },
  },
});
